import { Container, ContainerPadding, Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { PortalContext } from '../../../../../context/portal-context';

export const PopupHuchaContent = ({
	portalContext,
	handlePopupClose,
	layerContent,
}: {
	portalContext: any;
	handlePopupClose: () => void;
	layerContent: () => JSX.Element | null;
}) => {
	return (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handlePopupClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{layerContent()}
		</PortalContext.Provider>
	);
};
